var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlueOuterLinkArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#14BAD8",
    fillRule: "evenodd",
    d: "M2 1h3a1 1 0 0 1 .117 1.993L5 3H3v10h10v-2a1 1 0 0 1 1.993-.117L15 11v3a1 1 0 0 1-.883.993L14 15H2a1 1 0 0 1-.993-.883L1 14V2a1 1 0 0 1 .883-.993L2 1h3zm12 0a1.02 1.02 0 0 1 .484.125.878.878 0 0 1 .133.088c.063.05.12.107.17.17l-.08-.09a1.008 1.008 0 0 1 .282.559A.997.997 0 0 1 15 2l-.004-.086.003.054L15 2v5a1 1 0 0 1-2 0V4.414L7.707 9.707a1 1 0 0 1-1.497-1.32l.083-.094L11.584 3H9a1 1 0 0 1-.993-.883L8 2a1 1 0 0 1 1-1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueOuterLinkArrow);
export default __webpack_public_path__ + "static/media/blue-outer-link-arrow.6eca3377abe902fa242d83b4bf52824a.svg";
export { ForwardRef as ReactComponent };